export const Colors = {
  main: "rgba(230, 57, 70, 1)",
  textColor: "rgba(241, 250, 238, 1)",
  secondary: "rgba(168, 218, 220, 1)",
  light: "rgba(69, 123, 157, 1)",
  dark: "rgba(29, 53, 87, 1)",
  containerBackground:'white',
};
